import styled from 'styled-components';

export const LoadingButtonWrapper = styled.div`
  display: inline-block;
  
  /* Se houver necessidade de largura total */
  ${props => props.fullWidth && `
    display: block;
    width: 100%;
    
    button {
      width: 100%;
    }
  `}
`;



// WEBPACK FOOTER //
// ./src/design-system/molecules/LoadingButton/components/LoadingButtonStyles.js